import {Injectable, signal} from '@angular/core';
import {Anexo} from '@core/models/anexo';
import {DadosLocalizacaoDemanda, DescricaoDemanda} from '@core/models/demanda';

@Injectable()
export class AdicionarDemandaStateService {
  readonly activeStep = signal(0);
  readonly orientacoesExibidas = signal(false);
  readonly dadosLocalizacao = signal<DadosLocalizacaoDemanda | null>(null);
  readonly tipoObraId = signal<number | null>(null);
  readonly anexos = signal<Anexo[]>([]);
  readonly descricaoDemanda = signal<DescricaoDemanda | null>(null);

  setDescricao(dados: DescricaoDemanda): void {
    this.descricaoDemanda.set(dados);
  }

  setLocalizacao(dados: DadosLocalizacaoDemanda, tipoObraId: number): void {
    this.dadosLocalizacao.set(dados);
    this.tipoObraId.set(tipoObraId);
  }

  limparLocalizacao(): void {
    this.dadosLocalizacao.set(null);
    this.tipoObraId.set(null);
  }

  setAnexos(list: Anexo[]): void {
    this.anexos.set(list);
  }

  irParaStep(step: 0 | 1 | 2): void {
    this.activeStep.set(step);
  }
}
